<template>
  <div>
    <div>
      <el-carousel trigger="hover" height="800px" :interval="12000">
        <el-carousel-item v-for="(item, bannarDesc) in imgList" :key="bannarDesc">
          <img v-bind:src="api + item.bannarUrl"/>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="url2box">
      <div class="urlbox2" >
          <!-- <img src="../../static/img/moreImg.png" class="urlImg" alt="" width="100%" id="ejimg1"> -->
          <div class="urlNameWrapper">
            <div class="urlName" v-for="(item,index) in urlList" :key="index" @click="openUrl(item,index)">{{item.menuName}}</div>
          </div>
      </div>
    </div>
<!--    <div class="lowerbox">
      <div class="mlbox">
        <div><a style="color:#ffffff ">石材用胶粘剂 产品世界</a></div>
        <div class="pctitle">Knowledge of Stone</div>
      </div>
      <div class="cpb">
        <div class="cpbox2" v-for="(item,index) in listData2" :key="index" @click="openDetails(item,index,'name2')">
          <div class="cpsimg" s><img :src="api + item.icon" class="cpimg" style="height: inherit;" alt=""></div>
          <div class="cpname">
            <div class="detailbox">点击查看详情</div>
          </div>
        </div>
      </div>
    </div>-->
    <div class="lowerbox">
      <div class="mlbox">
        <div><a style="color:#FFFFFF ">石材用胶粘剂 产品世界</a>  </div>
        <div class="pctitle">Product World</div>
      </div>
      <div class="cpb">
        <div class="cpbox1" v-for="(item,index) in listData1" :key="index" @click="openDetails(item,index,'name1')">
          <div class="cpsimg"><img :src="api + item.icon" class="cpimg" alt=""></div>
          <div class="cpname">
            <div class="titleName">{{item.menuName}} </div>
            <!--            <div>{{ item.productName }}</div>-->
            <div class="detailbox">点击查看详情</div>
          </div>
        </div>
      </div>
    </div>

    <!--    <div class="lowerbox">
      <div class="mlbox">
        <div><a style="color:#008D40 ">产品世界</a>  </div>
        <div class="pctitle">Product World</div>
      </div>
      <div class="cpb">
        <div class="cpbox" v-for="(item,index) in listData1" :key="index" @click="openDetails(item,index,'name1')">
          <div class="cpsimg"><img :src="api + item.productPhoto[0]" class="cpimg" alt=""></div>
          <div class="cpname">
            <div class="titleName">{{item.productName}} </div>
            &lt;!&ndash;            <div>{{ item.productName }}</div>&ndash;&gt;
            <div class="detailbox">查看详情</div>
          </div>
        </div>
      </div>
    </div>
    <div class="lowerbox">
      <div class="mlbox">
        <div><a style="color:#008D40 ">石材的知识</a>  </div>
        <div class="pctitle">Knowledge of Stone</div>
      </div>
      <div class="cpb">
        <div class="cpbox" v-for="(item,index) in listData2" :key="index" @click="openDetails(item,index,'name2')">
          <div class="cpsimg"><img :src="api + item.productPhoto[0]" class="cpimg" alt=""></div>
          <div class="cpname">
            <div class="titleName">{{item.productName}} </div>
            &lt;!&ndash;            <div>{{ item.productName }}</div>&ndash;&gt;
            <div class="detailbox">查看详情</div>
          </div>
        </div>
      </div>
    </div>-->

<!--    <div class="lowerbox">
      <div class="mlbox">
        <div>石材用胶粘剂 产品世界</div>
        <div class="pctitle">PRODUCT WORLD</div>
      </div>
      <div class="cpb">
        <div class="cpbox" v-for="(item,index) in listData.slice(0,6)" :key="index" @click="openDetails(item)">
          <div class="cpimg"><img :src="api + item.productPhoto[0]" class="cpimg" alt=""></div>
          <div class="cpname">
            <div>{{ item.productName }}</div>
          </div>
        </div>
      </div>
    </div>-->


    <div class="lowerbox">
      <div class="mlbox">
        <div>企业中心</div>
        <div class="pctitle">ENTERPRISE CENTER</div>
      </div>
      <div class="jsbox">
        <div class="imgbox">
        </div>
        <div class="introduce">
          <div class="cenbox">湖南神力胶业集团</div>
          <div class="textbox">创建于1989年，专业从事有机高分子化合胶粘剂研发/生产/贸易于一体的企业，主要生产石材胶和其他粘胶剂</div>
          <div class="textbox">
            湖南神力胶业集团创建于1989年11月，是一家专业从事有机高分子化合胶粘剂研发、生产、贸易于一体且具有全部自主知识产权的企业。总部座落在长沙国家生物医药园(浏阳工业园)。紧靠319国道，东距长沙市36公里，离长沙市黄花国际机场20公里。公司占地面积19800平方米，地处长浏、岳汝、昌平、浏大四条高速公路交界处，长、株、潭城际轻轨贯穿全境，交通便利。优美的自然环境、便捷的交通环境、高速发展的人文科技环境，孕育出了这家蓝色、漂亮、齐整的现代化企业。神力荣耀成为世界花炮之都浏阳又一崭新的名片。
          </div>
          <div class="more" @click="opensl()">了解更多</div>
        </div>
      </div>
    </div>
<!--    <div class="lowerbox widthbox">-->
<!--      <div class="mlbox">-->
<!--        <div>新闻中心</div>-->
<!--        <div class="pctitle">ENTERPRISE CENTER</div>-->
<!--      </div>-->
<!--      <div class="newsboxs">-->
<!--        <div class="newsbigbox">-->
<!--          <div>-->
<!--            <img src="../../static/img/img.jpg" alt="" style="width: 100%">-->
<!--          </div>-->
<!--          <div class="newbox1" @click="menuList(this.oneNewTitle,this.oneNewTitle.menuId,this.oneNewTitle,this.oneNewTitle.childIndex)">-->
<!--            {{oneNewTitle.menuName}}-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="newbox2" >-->
<!--          <div class="titlebox1" v-for="(item,childIndex) in newsTitle">-->
<!--              <div class="timebox">-->
<!--                <div class="daybox">{{ item.createTime.slice(8,10) }}</div>-->
<!--                <div class="nianbox">{{ item.createTime.slice(0,7) }}</div>-->
<!--              </div>-->
<!--            <div class="titles" @click="menuList(item,item.menuId,item,childIndex)">{{ item.menuName }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="lowerbox widthbox">
      <div class="flexsbox">
        <div style="width: 100%;min-height: 500px">
          <div class="flexsbox">
<!--            <div class="newtit">-->
<!--              <div>新闻中心</div>-->
<!--              <div class="pctitle">NEWS CENTER</div>-->
<!--            </div>-->
            <div class="tabbox">
              <div :class="{'active':active_btn==index}" v-for="(item,index) in newsList1" :key="index"
                   @click="newsDetails(index,item)">{{item.menuName}}
              </div>
            </div>
          </div>
          <div class="newDetail">
            <div>
<!--              <img src="../../static/img/054fdf4d7b696fca412a802db1694c1.jpg" style="width: 100%; max-width: 550px " alt="">-->
            </div>
          </div>
          <div class="newtext">
          <div class="newbox" v-for="(item,childIndex) in newsTitle" :key="childIndex">
              <div class="newtitle" @click="menuList(item,item.menuId,item,childIndex)"><span class="spot">·</span>
                <span>{{item.menuName}}</span>
              </div>
          </div>
          </div>
        </div>
<!--        <div class="news" v-for="item1 in newsList2">-->
<!--          <div>{{ item1.menuName }}</div>-->
<!--          <div class="newbox">-->
<!--            <div class="newtitle" v-for="item2 in item1.children" @click="openFile(item2)"><span class="spot">·</span>{{ item2.menuName }}</div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
    <div class="flexbox">
      <div class="flexImg"><img src="../../static/img/home1.png" alt=""></div>
      <div class="flexImg"><img src="../../static/img/home2.png" alt=""></div>
      <div class="flexImg"><img src="../../static/img/home3.png" alt=""></div>
    </div>

  </div>
</template>
<script>
let api = 'https://www.slfangshuijiao.com/api';
let deptId = 110;
export default {
  name: 'Shouye',
  data() {
    return {
      urlList: [],
      newsTitle: [],
      oneNewTitle: [],
      newsList: [],
      newsList1: [],
      newsList2: [],
      active_btn: 0,
      activeName: 'first',
      imgList: [],
      listData1: [],
      listData2: [],
      //产品分页
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        type: '',
        gjz: '',
      },
      menuId:'',
      name1:'',
      name2:'',
      api,
      columnData:[]
    }
  },
  created() {

  },
  mounted() {
    this.lmList()
    this.lbList()
    this.newList()
    // this.zxSubmit()
    // this.zxSubmit2()
  },
  methods: {
    //获取导航栏
    lmList() {
      let that = this;
      that.$axios.post(api + '/site/columnList', {
        deptId: deptId
      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          if (res.data.data) {
            var arr = []
            res.data.data.forEach(item => {
              if (item.visible == 0) {
                arr.push(item)
              }
            })
            console.log(111, arr);
            that.columnData = that.handleTree(arr, 'menuId', 'parentId')
            console.log('columnData', that.columnData)
          }
        } else {
          that.$message.error(res.message);
        }
      })
    },
    //了解更多跳转
    opensl(){
      window.location = '/#/ejml?id=18&name=走进神力';
      document.documentElement.scrollTop = 0;
    },
    //打开文件
    openFile(item){
      window.open(api + item.target)
    },
    openUrl(item,index) {
      index = 0
      if (item.menuName != "首页") {
        if (item.menuName === "产品世界") {
          //menuId 获取当前点击的第一章-第一节-第一个的menuId
          window.location = '/#/cplist?id=' + item.menuId + '&name=' + encodeURI(item.menuName) + '&index=' + index+ '&titName=' + item.children[0].menuName + '&menuId=' + item.children[0].children[0].children[0].menuId;

          // console.log(item,item.children[0].children[0].children[0].menuId)
          // window.location = '/#/cplist?id=' + item.menuId + '&name=' + encodeURI(item.menuName)+ '&menuId=' + item.menuId;
        } else {
          window.location = '/#/ejml?id=' + item.menuId + '&name=' + encodeURI(item.menuName);
        }
        window.location.reload();
      } else {
        window.location = '/#/';
        window.location.reload();
      }
    },
    //跳转产品详情页面
    openDetails(item,index,name) {
      console.log(666,item,index,name);
      if (name == 'name1'){
        name = this.name1
      }else {
        name = this.name2
      }
      let menuId = ''
      if (item.children){
        menuId = item.children[0].menuId
      }else {
        menuId = item.menuId
      }
      window.location = "/#/cplist?id=" + this.menuId + '&name=产品世界'+ '&index=' + index+ '&titName=' + name + '&menuId=' + menuId
      // window.location = "/#/cpdetails?id=" + item.productId + '&name=' + encodeURI(item.productName)
    },
    newsDetails(index, items) {
      console.log('点击',items);
      this.newsList1.forEach(item => {
        if (item.menuName == items.menuName) {
          this.newsTitle = item.children
        }
      })
      this.active_btn = index
    },
    handleClick(tab, event) {
    },
    //新闻列表
    newList() {
      let that = this;
      that.$axios.post(api + '/site/columnList', {
        deptId: deptId
      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          if (res.data.data) {
            that.newsList = that.handleTree(res.data.data, 'menuId', 'parentId')
            console.log(6666,that.newsList);
            //建筑用胶粘剂产品世界数据
            that.newsList.forEach(item=>{
              if (item.menuName == '产品世界'){
                that.listData1 = item.children[0].children
                that.listData2 = item.children[1].children
                that.menuId = item.menuId
                that.name1 = item.children[0].menuName
                that.name2 = item.children[1].menuName
              }
            })
            console.log('建筑用胶粘剂产品世界数据',that.listData1,that.listData2);
            var newArr1 = []
            // var newArr2 = []
            that.newsList.forEach(item => {
              if (item.visible == 1){
                newArr1.push(item)
              }
            })
            that.newsList1 = newArr1
            console.log(111122222222,newArr1)

            if (newArr1) {
              //获取轮播图下方导航栏
              newArr1.forEach((item,index)=>{
                if (item.menuId == 1491 || item.menuName == '轮播图下方导航栏'){
                  that.urlList = item.children
                  return
                }
              })
              that.oneNewTitle = newArr1[0].children[0]
              newArr1[0].children.forEach((item,index)=>{
                // if (index > 0 && index<5){
                item.createTime = item.createTime.slice(0,10)
                that.newsTitle.push(item)
                // }
              })
            }
            console.log('shuju',newArr1[0].children,that.newsTitle);
            console.log('一条',that.oneNewTitle);
          }
        } else {
          that.$message.error(res.message);
        }
      })
      /*let that = this;
      that.$axios.post(api + '/site/columnList', {
        deptId: deptId
      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          if (res.data.data) {
            that.newsList = that.handleTree(res.data.data, 'menuId', 'parentId')
            var newArr1 = []
            // var newArr2 = []
            that.newsList.forEach(item => {
              if (item.menuName == '新闻报导') {
                newArr1.push(item)
              } else if (item.menuName == '聘兼职业务员') {
                newArr1.push(item)
              } else if (item.menuName == '产品世界') {
                newArr1.push(item)
                that.menuId = item.menuId
                that.name1 = item.children[0].menuName
                that.name2 = item.children[1].menuName
                console.log('name1----',that.name1,that.name2);
              } else if (item.menuName == '国家部门对防水推广') {
                newArr1.push(item)
              } else if (item.menuName == '国家荣誉证书') {
                newArr1.push(item)
              } else if (item.menuName == '中央领导关注') {
                newArr1.push(item)
              }
            })
            that.newsList1 = newArr1
            console.log(1111,newArr1)
            // that.newsList2 = newArr2
            if (newArr1) {
              // that.newsTitle = newArr1[0].children
              that.oneNewTitle = newArr1[0].children[0]

              newArr1[0].children.forEach((item,index)=>{
                // if (index > 0 && index<5){
                  item.createTime = item.createTime.slice(0,10)
                  that.newsTitle.push(item)
                // }
              })
            }
            console.log('shuju',newArr1[0].children,that.newsTitle);
            console.log('一条',that.oneNewTitle);
          }
        } else {
          that.$message.error(res.message);
        }
      })*/
    },

    //二级跳转方法
    menuList(item1, id, item2, index) {
      console.log('跳转信息', item1, item2, index);
      // return
      let that = this;
      that.$axios.post(api + '/site/columnDetail', {
        columnId: id
      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          if (item1.menuType === 'D') {
            window.location = '/#/cplist?id=' + item2.menuId + '&name=' + encodeURI(item2.menuName) + '&index=' + index;
            document.documentElement.scrollTop = 0;
            window.location.reload();
          } else if (item1.menuType === 'C') {
            if(item1.target != ''){
              window.open(api + item1.target)
            }
          } else if (res.data.data.length > 0) {
            if (item1.menuType === 'F' && item1.perms == '') {
              that.$message('暂无数据');
              return
            } else if (item1.menuType === 'M' && item1.children == '') {
              that.$message('暂无数据');
              return
            } else if (item1.menuType === 'M') {
              window.location = '/#/ejml?id=' + item2.menuId + '&name=' + encodeURI(item2.menuName) + '&index=' + 0;
              document.documentElement.scrollTop = 0;
              window.location.reload();
            } else if (item1.menuType === 'F') {
              window.location = '/#/ejml?id=' + item2.menuId + '&name=' + encodeURI(item2.menuName) + '&index=' + 0;
              document.documentElement.scrollTop = 0;
              window.location.reload();
            }
          }
        } else {
          that.$message.error(res.message);
        }
      })
    },

    // 轮播图列表
    lbList() {
      let that = this;
      let num =0
      if (screen.width > 765){
        num=1
      }else{
        num=2
      }
      that.$axios.post(api + '/site/bannarList', {
        deptId: deptId,
        bannarType:num
      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        // console.log('轮播',res)
        if (res.data.code == '0') {
          if (res.data.data) {
            console.log(res.data.data)
            that.imgList = res.data.data
          }
        } else {
          that.$message.error(res.message);
        }
      })
    },
    //产品列表
    zxSubmit() {
      let that = this;
      that.$axios.post(api + '/site/productList', {
        columnId: 349,
        deptId:deptId,
        pageNum: this.queryParams.pageNum,
        pageSize: this.queryParams.pageSize,
        param: this.queryParams.gjz,

      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          if (res.data.data) {
            that.listData1 = res.data.data.rows
            that.listData1.forEach(item => {
              item.productPhoto = item.productPhoto.split(',')
            })
            that.total = res.data.data.total
          }
        } else {
          that.$message.error(res.message);
        }
      })
    },
    //产品列表
    zxSubmit2() {
      let that = this;
      that.$axios.post(api + '/site/productList', {
        columnId: 360,
        deptId:deptId,
        pageNum: this.queryParams.pageNum,
        pageSize: this.queryParams.pageSize,
        param: this.queryParams.gjz,

      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          if (res.data.data) {
            that.listData2 = res.data.data.rows
            that.listData2.forEach(item => {
              item.productPhoto = item.productPhoto.split(',')
            })
            that.total = res.data.data.total
          }
        } else {
          that.$message.error(res.message);
        }
      })
    },
    //树形转换
    handleTree(data, id, parentId, children) {
      debugger
      let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children'
      };

      var childrenListMap = {};
      var nodeIds = {};
      var tree = [];

      for (let d of data) {
        let parentId = d[config.parentId];
        if (childrenListMap[parentId] == null) {
          childrenListMap[parentId] = [];
        }
        nodeIds[d[config.id]] = d;
        childrenListMap[parentId].push(d);
      }

      for (let d of data) {
        let parentId = d[config.parentId];
        if (nodeIds[parentId] == null) {
          tree.push(d);
        }
      }

      for (let t of tree) {
        adaptToChildrenList(t);
      }

      function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
          o[config.childrenList] = childrenListMap[o[config.id]];
        }
        if (o[config.childrenList]) {
          for (let c of o[config.childrenList]) {
            adaptToChildrenList(c);
          }
        }
      }

      return tree;
    },
  }
}
</script>
<style scoped>
.urlImg {
  width: 150px;
  margin-bottom: -20px;
  padding: 15px 0;
}
.urlName{
  font-size: 16px;
  border-radius: 25px;
  background:linear-gradient(to right,#EE9AE5,#C71BFF,#7030A0);
  min-width: 110px;
  margin: 14px auto;
  color: #fff;
  padding: 10px;
  float: left;
  margin-right: 10px;
  text-align: center;
  cursor: pointer;
  margin-bottom: 23px;
}
.urlbox{
  float: left;
}
.urlbox2{
  width: 100%;
}
.url2box{
  padding: 25px;
  background: #FFF000;
  width: 100%;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;     /* 垂直居中 */
}

.urlNameWrapper {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-auto-rows: minmax(60px, auto);
  gap: 10px;
  width: 100%;
  justify-items: center;
  max-height: 210px; /* 3行的最大高度 */
  overflow-y: auto;
}

.urlName {
  font-size: 16px;
  border-radius: 25px;
  background:linear-gradient(to right,#EE9AE5,#C71BFF,#7030A0);
  min-width: 110px;
  color: #fff;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  width: calc(100% - 10px);
  box-sizing: border-box;
  margin: 5px 0;
}
.ubox{
  margin: auto;
  overflow: auto;
}
/*.newsboxs{*/
/*  display: flex;*/
/*  padding: 20px 0;*/
/*}*/
/*.newsbigbox{*/
/*  width: 50%;*/
/*  background: #fff*/
/*}*/
/*.timebox{*/
/*  text-align: center;*/
/*  background-color: #8E8E8E;*/
/*  padding: 10px;*/
/*}*/
/*.titlebox1{*/
/*  background-color: #FFFFFF;*/
/*  padding: 15px;*/
/*  display: flex;*/
/*  margin-bottom: 10px*/
/*}*/
/*.nianbox{*/
/*  font-size: 14px;*/
/*  color: #fff;*/
/*}*/
/*.titles{*/
/*  padding: 15px;*/
/*}*/
/*.daybox{*/
/*  font-size: 24px;*/
/*  color: #FFFFFF;*/
/*}*/
/*.newbox2{*/
/*  padding: 0 15px;*/
/*  width: 50%;*/
/*}*/
/*.newbox1{*/
/*  display: block;*/
/*  width: 100%;*/
/*  overflow: hidden;*/
/*  text-overflow: ellipsis;*/
/*  white-space: nowrap;*/
/*  font-size: 18px;*/
/*  color: #515671;*/
/*  font-weight: bold;*/
/*  height: 50px;*/
/*  line-height: 50px;*/
/*  padding: 0 10px;*/
/*}*/

.flexbox{
  padding: 40px 0;
  width: 90%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-left: 190px;
}
.flexImg img{
  width: 70%;
}
.spot {
  color: #ffde00;
  padding: 0 5px;
  width: 20px;
  height: 20px;
  border-radius: 50px;
}
.newtitle>span:hover{
  color: #000;
  background-color: #ffde00;
  padding: 5px;
}
.widthbox {
  height: 520px;
}

.newcontent {
  color: #989898;
  font-size: 14px;
  padding: 15px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.newtitle {
  font-weight: 600;
  cursor: pointer;
}

.newbox {
  padding: 15px 0;
}
.newtext{
  max-height: 420px;
  overflow: auto;
  padding: 0 55px;
}
.newDetail {
  float: left;
  /*width: calc(100% - 50%);*/
  padding: 15px;
}

.borbox {
  width: 30%;
  border-left: solid 1px #CACACA;
}

.titbox {
  padding: 0 15px;
  cursor: pointer;
}

.active {
  color: red;
  font-weight: 600;
  background: #ffde00;
  border-radius: 2px;
}

.tabbox div {
  border: 1px solid #cacaca;
  /*padding: 10px 15px;*/
  cursor: pointer;
  font-weight: 600;
  width: 15% !important;
  margin-bottom: 15px;
  text-align: center !important;
}

.news {
  border-left: solid 1px #CACACA;
  padding: 15px;
  font-weight: 600;
  width: 30%;
}

.new div {
  color: #009444;
}

.newtit {
  border-left: solid 5px #ffde00;
  height: 43px;
  padding: 0px 10px;
  font-size: 18px;
  font-weight: 600;
}

.tabbox {
  display: flex;
  padding: 15px;
  justify-content: space-between;
  width: calc(100% - 200px);
}

.flexsbox {
  display: flex;
}

.more {
  color: #06A0F6;
  float: right;
  font-size: 16px;
  cursor: pointer;
}

.textbox {
  text-indent: 2em;
  line-height: 2.2;
}

.cenbox {
  text-align: center;
  padding: 15px;
  font-weight: 600;
}

.jsbox {
  width: 100%;
  display: flex;
}

.introduce {
  background: #FFFFFF;
  padding: 15px;
  height: 350px;
  margin-top: 40px;
  border-radius: 15px;
  margin-left: -200px;
  width: 700px;
  z-index: 2;
}

.imgbox {
  margin: 15px 0 0px 40px;
  width: 60%;
  height: 400px;
  /*z-index:1;*/
  /*position: absolute;*/
  background-image: url("../../static/img/img.jpg");
  background-size: 100% 100%;
}

.lowerbox {
  background-color: #F5F5F5;
  padding: 25px;
  margin: 20px 0;
  margin-left: 3%;
  width: 90%;
}

.mlbox {
  border-radius: 25px;
  background:linear-gradient(to right,#EE9AE5,#C71BFF,#7030A0);
  padding: 5px 15px;
  font-size: 20px;
  font-weight: 600;
  color: #FFFFFF;
  width: fit-content;
  min-width: 130px;
}

.pctitle {
  font-size: 10px;
}

.cpb {
  padding: 15px 0;
  overflow: auto;
}

.cpbox1 {
  width: calc(100% / 6 - 30px) ;
  float: left;
  margin: 15px;
  cursor: pointer;
}
.cpbox2 {
  width: calc(100% / 2 - 260px) ;
  float: left;
  /*margin: 15px;*/
  margin-left: 180px;
  cursor: pointer;
}
.cpsimg{
  text-align: center;
}
.cpbox {
  width: calc(100% / 3 - 35px);
  float: left;
  margin: 15px;
  cursor: pointer;
}

.cpimg {
  height: 220px;
  /*width: 200px;*/
  object-fit: cover;
}

.cpname {
  background-color: #F7F7F7;
  text-align: center;
  padding: 0px;
}

.titleName{
  height: 55px;
}
.detailbox{
  font-size: 14px;
  border-radius: 25px;
  background:linear-gradient(to right,#EE9AE5,#C71BFF,#7030A0);
  width: 110px;
  margin: 14px auto;
  color: #FFFFFF;
  padding: 5px;
}
.xqbox {
  color: rgb(158, 159, 159);
  font-size: 12px;
}
@media screen and (max-width: 500px) {
  .cpbox2{
    width: calc(50% - 30px);
    float: left;
    margin: 15px;
    cursor: pointer;
  }
  .cpbox1 {
    width: calc(50% - 30px);
    float: left;
    margin: 15px;
    cursor: pointer;
  }
  .flexsbox{
    display: block!important;
    overflow: hidden !important;
  }
  .newtext{
    overflow: auto;
    max-height: 320px;
    padding: 15px;
  }
  .flexbox{
    margin-left: 0px;
    padding: 0;
    display: block;
    width: 90% !important;
    margin: auto;
  }
  .flexbox div{
    margin-bottom: 15px;
  }
  .flexImg img{
    width: 100% !important;
  }
  .newsbigbox{
    width: 100%  !important;
  }
  .newsboxs{
    display: block;
  }
  .newbox2{
    width: 100%;
    padding: 0px;
  }
  .widthbox{
    height: 100%;
  }
  .flexsbox{
    display: block!important;
  }
  .newtext{
   width: 320px;
    overflow: auto;
    max-height: 320px;
  }
  .tabbox {
    width: calc(100% - 5px);
    padding: 30px 0;
    max-height: 220px;
    margin-left: -20px;
}
  .tabbox div {
    padding: 3px 15px;
    cursor: pointer;
    font-weight: 600;
    width: 33% !important;
  }
  .introduce{
    background: #FFFFFF;
    padding: 15px;
    height: 350px;
    margin-top: -122px;
    border-radius: 15px;
    margin-left: 0px;
    width: 330px;}
  .imgbox {
    margin: 15px 0 90px 15px;
    width: 95%;
    height: 150px;
    border-radius: 15px;
    /*z-index:1;*/
    /*position: absolute;*/
    background-image: url("../../static/img/img.jpg");
    background-size: 100% 100%;
  }
  .jsbox{
    display:block;
  }
}
</style>
